<label for="txtattactments" class="form-label text__custom-label"> {{text|translate}} <span *ngIf="isNecessary">*</span></label>
<input type="file" #fileInput id="listAttactments" accept="{{accept}}" (change)="onFileSelected($event)" hidden [multiple]="isMultiple">
<button type="button" class="choose-file" (click)="fileInput.click()">
  {{'LABEL.CHONFILE'|translate}}
</button>
<span class="e-float-line"></span>

<!-- Hiển thị danh sách file đã chọn -->
<ul *ngIf="selectedFiles.length > 0">
  <li *ngFor="let file of selectedFiles; let i = index">
    {{ file.Name }}
    <button type="button" (click)="removeFile(i)" style="color: red; border: none; background: none;">✖</button>
  </li>
</ul>
<span class="errorTxt__custom" *ngIf="errMessage != ''">
    {{ errMessage }}
</span>
